export const PT_TIMEZONE = "America/Los_Angeles";

export const DATE_PRESETS = [
  { key: "last7", label: "Last 7 days" },
  { key: "last30", label: "Last 30 days" },
  { key: "mtd", label: "Month to date" },
  { key: "lastFullMonth", label: "Last full month" },
  { key: "custom", label: "Custom" },
];

export const RETENTION_WINDOWS = [
  { key: "d7", label: "D7", startDays: 7, endDays: 14 },
  { key: "d30", label: "D30", startDays: 30, endDays: 60 },
  { key: "d90", label: "D90", startDays: 90, endDays: 120 },
];

export const HABIT_BUCKETS = [
  { label: "0-1", min: 0, max: 1 },
  { label: "2-3", min: 2, max: 3 },
  { label: "4-7", min: 4, max: 7 },
  { label: "8-14", min: 8, max: 14 },
  { label: "15-30", min: 15, max: 30 },
  { label: "31+", min: 31, max: Infinity },
];

export const PLANT_DISTRIBUTION_USER_LIMIT = 3500;
export const ACTIVE_USER_SAMPLE_LABEL = "Active users only";
export const COHORT_PAGE_SIZE = 12;
export const MAX_IN_QUERY = 10;

export const CHART_COLORS = {
  waterings: "#34a853",
  chats: "#1a73e8",
  total: "#7c3aed",
  background: "#f8fafc",
};
